"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useForceUpdate = function () {
    var _a = react_1.useReducer(function (x) { return x + 1; }, 0), forceUpdate = _a[1];
    /**
     * Calls a force update function whenever the formData state changes.
     * This is needed because transformErrors callback is called before the latest formData state is updated,
     * so a force update is required to ensure that the latest state is used.
     */
    return { forceUpdate: forceUpdate };
};
exports.default = useForceUpdate;
